import { createContext, useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
    const location = useLocation();
    const previousLocationRef = useRef(null);

    useEffect(() => {
        if (!location.state?.disableTracking) {
            previousLocationRef.current = {
                pathname: location.pathname,
                state: location.state
            };
        }
    }, [location]);

    const getPrevious = () => previousLocationRef.current;

    return (
        <NavigationContext.Provider value={{ getPrevious }}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigationTracker = () => useContext(NavigationContext);